import { SectionHeading } from '@/features/approving_invoice_reports/components/PaymentDetailDrawer/components/SectionHeading';
import { AnchorSectionKey } from '@/features/approving_invoice_reports/components/PaymentDetailDrawer/hooks/anchor';
import { useTranslation } from '@/i18n';
import { FC, memo } from 'react';
import { JournalInfoLayoutSwitch } from './LayoutSwitch';

type JournalInfoProps = { reportId: string };

export const JournalInfo: FC<JournalInfoProps> = memo(({ reportId }) => {
  const { t } = useTranslation();

  return (
    <SectionHeading
      id={AnchorSectionKey.JOURNAL}
      title={t('journal_entry.section_title')}
    >
      <JournalInfoLayoutSwitch reportId={reportId} />
    </SectionHeading>
  );
});
JournalInfo.displayName = 'JournalInfo';
